import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  public year: number = 0;

  constructor() { }

  ngOnInit() {
    this.year = new Date().getFullYear();
  }

  getVersion(){
    return environment.VERSION
;
  }
}
